import { setfontList } from "@/common/design";
import { useSdkStore } from "@/stores/sdk";

export const initDesign = async () => {
    await setfontList()
}
